import { Component, Input, OnInit } from '@angular/core';
import { SearchTableViewModel } from '../../../view-models/search-table.view-model';

@Component({
  selector: 'app-search-table-header',
  templateUrl: './search-table-header.component.html',
  styleUrls: ['./search-table-header.component.scss'],
  standalone: false,
})
export class SearchTableHeaderComponent implements OnInit {
  @Input()
  searchFieldPlaceholderText: string;

  @Input()
  searchTableViewModel: SearchTableViewModel<any>;

  @Input()
  perPageLabelText: string;

  public numberOfResultsPerPageChoices: number[] = [
    10,
    25,
    50,
    100,
    250,
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

  searchTextUpdated(value) {
    this.searchTableViewModel.searchText = value;
    this.searchTableViewModel.modelUpdated();
  }

  numberOfResultsPerPageUpdated(value) {
    this.searchTableViewModel.numberOfResultsPerPage = parseInt(value);
    this.searchTableViewModel.modelUpdated();
  }
}
